import { Spin } from "antd";
import { useGetContractVariablesQuery } from "AppQuries/master/ContractTemplate/contract-template";
import React from "react";
import PropTypes from "prop-types";

const ContractVariables = ({ variables, insertVariable, isLoading }) => {
  console.log(variables);

  if (isLoading) return <Spin size="small" spinning={isLoading} />;

  return (
    <div>
      <h5>Variables</h5>
      {variables?.map((v) => (
        <button
          key={v?.id}
          className="btn btn-outline-secondary btn-sm m-1"
          onClick={() => insertVariable(v?.variable)}
        >
          {v?.label}
        </button>
      ))}
    </div>
  );
};

ContractVariables.propTypes = {
  variables: PropTypes.array.isRequired,
  insertVariable: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default React.memo(ContractVariables);
